/* レスポンスダイアログ */
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
var ResponseDialog = function (_a) {
    var is_confirm = _a.is_confirm, show = _a.show, title = _a.title, body = _a.body, ClickCallBackYes = _a.ClickCallBackYes, ClickCallBackNo = _a.ClickCallBackNo, ClickCallBackConfirm = _a.ClickCallBackConfirm, t = _a.t;
    return (React.createElement(Modal, { size: "lg", centered: true, show: show, onHide: function () { } },
        React.createElement(Modal.Header, null,
            React.createElement(Modal.Title, { className: "dialog-title" }, title)),
        React.createElement(Modal.Body, { className: "dialog-body" }, body),
        React.createElement(Modal.Footer, null, is_confirm ? (React.createElement(Button, { variant: "main-color", onClick: ClickCallBackConfirm }, t('確認'))) : (React.createElement(React.Fragment, null,
            React.createElement(Button, { variant: "main-color", onClick: ClickCallBackYes }, t('はい')),
            React.createElement(Button, { variant: "main-color", onClick: ClickCallBackNo }, t('いいえ')))))));
};
export default ResponseDialog;
